import { toast } from 'react-toastify';

export const handleValidationErrors = (error, defaultMessage = 'An error occurred. Please try again.') => {
  if (error.isValidationError && error.validationErrors) {
    // Handle validation errors
    const errors = error.validationErrors;
    Object.keys(errors).forEach(field => {
      const fieldErrors = errors[field];
      if (Array.isArray(fieldErrors)) {
        fieldErrors.forEach(errorMsg => {
          toast.error(`${field}: ${errorMsg}`);
        });
      }
    });
  } else {
    toast.error(defaultMessage);
  }
};

export const formatFieldName = (fieldName) => {
  const fieldMap = {
    // Product fields
    'name': 'Product Name',
    'brand_name': 'Brand Name',
    'category': 'Category',
    'ram': 'RAM',
    'storage': 'Storage',
    'suffix': 'Suffix',
    'thumbnail_image': 'Thumbnail Image',
    'is_new_device': 'New Device',
    'is_used_device': 'Used Device',
    // Customer fields
    'email': 'Email Address',
    'mobile': 'Phone Number',
    'gender': 'Gender',
    'address': 'Address'
  };
  
  return fieldMap[fieldName] || fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
};

export const handleFormattedValidationErrors = (error, defaultMessage = 'An error occurred. Please try again.') => {
  if (error.isValidationError && error.validationErrors) {
    // Handle validation errors with formatted field names
    const errors = error.validationErrors;
    Object.keys(errors).forEach(field => {
      const fieldErrors = errors[field];
      const formattedFieldName = formatFieldName(field);
      
      if (Array.isArray(fieldErrors)) {
        fieldErrors.forEach(errorMsg => {
          toast.error(`${formattedFieldName}: ${errorMsg}`);
        });
      }
    });
  } else {
    toast.error(defaultMessage);
  }
};
